import styled from 'styled-components';
import { theme } from '../../../../../../../utils/theme';

const QuoteIcon = () => (
  <StyledSvg
    xmlns='http://www.w3.org/2000/svg'
    width='40'
    height='30'
    viewBox='0 0 55 40'
    fill='none'
    aria-hidden='true'
  >
    <path
      d='M12.445 40C8.88236 40 5.91798 38.7374 3.55186 36.2069C1.18306 33.6818 0 29.9294 0 24.9552C0 20.8363 0.789603 17.1463 2.36611 13.8854C3.94532 10.6245 6.02847 7.81971 8.61826 5.47651C11.208 3.1306 14.0026 1.306 16.9967 0L22.1574 3.91529C21.2654 4.36329 19.9125 5.22129 18.0908 6.48384C16.269 7.74912 14.6009 9.28862 13.081 11.1024C11.5638 12.9188 10.8038 14.8846 10.8038 17.0052C11.2485 16.5572 11.9572 16.2503 12.9274 16.0874C13.9002 15.9245 14.83 15.8431 15.7193 15.8431C17.8644 15.8431 19.9287 16.7092 21.9121 18.4415C23.8956 20.1738 24.8873 22.9976 24.8873 26.9128C24.8873 30.8281 23.6827 34.1406 21.2762 36.4838C18.8669 38.8298 15.9241 40 12.445 40ZM42.555 40C38.9924 40 36.028 38.7374 33.6619 36.2069C31.2958 33.6791 30.11 29.9294 30.11 24.9525C30.11 20.8336 30.8996 17.1436 32.4761 13.8827C34.0553 10.6218 36.1385 7.817 38.7283 5.4738C41.3181 3.12788 44.11 1.306 47.1067 0L52.2674 3.91529C51.3754 4.36329 50.0198 5.22129 48.2008 6.48384C46.3791 7.74912 44.7109 9.28862 43.1937 11.1024C41.6765 12.9188 40.9165 14.8846 40.9165 17.0052C41.3612 16.5572 42.0699 16.2503 43.0401 16.0874C44.0102 15.9245 44.9427 15.8431 45.832 15.8431C47.9771 15.8431 50.0414 16.7092 52.0248 18.4415C54.0083 20.1738 55 22.9976 55 26.9128C55 30.8281 53.7954 34.1406 51.3889 36.4838C48.9796 38.8298 46.0368 40 42.555 40Z'
      fill={theme.landing.colors.primary}
    />
  </StyledSvg>
);

export default QuoteIcon;

const StyledSvg = styled.svg`
  flex-shrink: 0;
`;
